import React, { FC } from 'react'

import { IconSyncProps } from './IconSync.types'
import * as Styled from './styles/IconSync.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSync: FC<IconSyncProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSyncProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconSyncProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M31 45.23A61 61 0 0 1 124.58 40h-30.4a4 4 0 0 0 0 8H132a4 4 0 0 0 4-4V6a4 4 0 0 0-8 0v26.07a69 69 0 0 0-116.28 59.6 4 4 0 0 0 7.92-1.17A60.6 60.6 0 0 1 31 45.23zm117.28 23.19a4 4 0 0 0-7.91 1.17A61 61 0 0 1 35.33 120h30.49a4 4 0 0 0 0-8H28a4 4 0 0 0-4 4v38.09a4 4 0 0 0 8 0V128a69 69 0 0 0 116.28-59.58z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSync
